import React, { useState } from "react"
import { ScrollMenu } from "react-horizontal-scrolling-menu"
import "./style.css"

// import "./globalStyles.css"
// import usePreventBodyScroll from "./usePreventBodyScroll"

// NOTE: embrace power of CSS flexbox!
// import "./hideScrollbar.css"

const CustomHorizontalScroll = (props) => {
   const items = [1, 23, 4, 5, 6,23,3,4,5,12,];
   // const { disableScroll, enableScroll } = usePreventBodyScroll()

   const onWheel = (apiObj, ev) => {
      const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15

      if (isThouchpad) {
         ev.stopPropagation()
         return
      }

      if (ev.deltaY < 0) {
         apiObj.scrollNext()
      } else if (ev.deltaY > 0) {
         apiObj.scrollPrev()
      }
   }


   return (
      <>
         <div id="custom-horizontal-scroll" className={props.className}>
            <div >
               <ScrollMenu
                  onWheel={onWheel}
               >
                  {props.children}
               </ScrollMenu>
            </div>
         </div>
      </>
   )
}

export default CustomHorizontalScroll
